<template>
  <div
    class="anz-mb-s anz-mt-m anz-fs-lead anz-color-black-50"
    v-if="isShowingCurrentUser"
  >
    {{ $translate('profile.labels.subscribersText1') }}
    <strong class="anz-strong anz-color-default">
      {{
        profile.isHideSubscribedUsers
          ? $translate('profile.labels.private')
          : $translate('profile.labels.public')
      }} </strong
    >.
    {{ $translate('profile.labels.subscribersText2') }}
    <a-button
      add-href
      :href="generateUserEditRoute()"
      :title="$translate('profile.actions.subscribersTextProfile')"
      class-name="anz-link anz-color-primary anz-link-hover-underline"
    />
  </div>
  <table class="anz-table anz-table--hover anz-mb-xl">
    <user-header />
    <tbody>
      <template v-for="subscriber in subscribers" :key="subscriber.id">
        <subscriber-user-item :subscriber="subscriber" />
      </template>
    </tbody>
  </table>
  <div class="anz-align-center">
    <a-loader v-if="loading" class-name="my-l"></a-loader>
    <a-button
      v-if="remaining > 0"
      class-name="anz-btn anz-btn-primary anz-wf-mo anz-btn-l"
      @click="loadNext"
    >
      <template #title>
        {{ $translate('profile.actions.loadNext') }}
        <template v-if="remaining > 0"> ({{ remaining }}) </template>
      </template>
    </a-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import useSubscriberManager from '@/composables/subscribers/subscribersManager'
import ALoader from '@/components/ALoader.vue'
import { useProfileShow } from '@/composables/user/user'
import UserHeader from '@/components/Profile/Lists/Single/UserHeader.vue'
import SubscriberUserItem from '@/components/Profile/Lists/Single/SubscriberUserItem.vue'
import { useRouter } from '@/routing/router'

export default defineComponent({
  name: 'SubscribersList',
  components: {
    SubscriberUserItem,
    UserHeader,
    ALoader,
    AButton,
  },
  props: {
    allowNest: {
      type: Boolean,
      default: true,
    },
  },
  async setup() {
    const {
      subscribers,
      remaining,
      loading,
      loadNext,
      clearList,
    } = useSubscriberManager()
    const { profile, isShowingCurrentUser } = useProfileShow()

    clearList()
    await loadNext()

    return {
      profile,
      loading,
      subscribers,
      remaining,
      loadNext,
      isShowingCurrentUser,
      ...useRouter(),
    }
  },
})
</script>
